export default class ValidCompose {
  constructor(afterTask) {
    if (typeof afterTask !== 'function') {
      throw new Error('Parameters can only be entered with functions.');
    }
    this.afterTask = afterTask;
  }

  get compose() {
    return (...tasks) => {
      if (tasks.length === 1) return tasks[0];
      return tasks.reduce((prevTask, nextTask) => inititalizer =>
        prevTask(nextTask(inititalizer))
      );
    };
  }

  get middleware() {
    return handler => next => payload => {
      if (payload instanceof InvalidTaskError) return next(payload);

      try {
        return next(handler(payload));
      } catch (err) {
        if (err instanceof InvalidTaskError) return next(err);
        return false;
      }
    };
  }

  setTasks(...tasks) {
    tasks.forEach(func => {
      if (typeof func !== 'function') {
        throw new Error('Parameters can only be entered with functions.');
      }
    });

    const task = tasks.map(func => this.middleware(func));

    return {
      tirgger: this.compose(...task)(this.afterTask),
    };
  }
}

export class InvalidTaskError extends Error {
  constructor(type) {
    super(type);
    this.type = type;
  }
}
